import { Box, ButtonBase, styled } from "@material-ui/core";
import type { ReactElement } from "react";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "./epocus-palette";

const Group = styled(Box)({
  display: "inline-flex",
  flexWrap: "wrap",
  gap: 4,
  padding: 4,
  borderRadius: 10,
  backgroundColor: EPOCUS_WHITE,
  border: `1px solid ${EPOCUS_BORDER}`,
});

const Segment = styled(ButtonBase)({
  padding: "8px 14px",
  minHeight: 44,
  borderRadius: 8,
  fontSize: rem(13),
  fontWeight: 600,
  color: EPOCUS_TEXT_SECONDARY,
  "&.selected": {
    backgroundColor: EPOCUS_PRIMARY,
    color: EPOCUS_WHITE,
  },
});

export const SegmentedPeriodSelector = <TKey extends string>({
  options,
  value,
  onChange,
  label,
}: {
  options: ReadonlyArray<{ key: TKey; label: string }>;
  value: TKey;
  onChange: (key: TKey) => void;
  label: string;
}): ReactElement => (
  <Group role="group" aria-label={label}>
    {options.map((option) => (
      <Segment
        key={option.key}
        aria-pressed={option.key === value}
        className={option.key === value ? "selected" : undefined}
        onClick={() => onChange(option.key)}
      >
        {option.label}
      </Segment>
    ))}
  </Group>
);
